import React, { useState } from 'react';
import BlogImagePlaceholder from './BlogImagePlaceholder';
import { blogImageFallbacks } from '../../utils/blogImageFallbacks';

interface BlogImageProps {
  src: string;
  alt: string;
  title: string;
  category: string;
  className?: string;
}

const BlogImage: React.FC<BlogImageProps> = ({ src, alt, title, category, className = "" }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const getFallbackImage = (src: string) => {
    const imageName = src.split('/').pop()?.replace('.svg', '') || 'default';
    return blogImageFallbacks[imageName as keyof typeof blogImageFallbacks] || blogImageFallbacks.default;
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (imageError) {
    return (
      <img
        src={getFallbackImage(src)}
        alt={alt}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }

  return (
    <div className={`relative ${className}`}>
      {!imageLoaded && (
        <div className="absolute inset-0 bg-gradient-to-br from-purple-800 to-pink-500 flex items-center justify-center">
          <div className="text-white text-center">
            <div className="text-lg font-bold mb-2">Loading...</div>
            <div className="text-sm opacity-80">Quixocial Blog</div>
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default BlogImage;